import { querySymbolsInFileFast } from '../symbol-index/query/query-symbols-in-file.js';
import type { CodeNavOpContext } from './code-nav-op-context.js';
import { fileBrowserReadInFlight } from '../../files/browser/in-flight.js';
import type { CodeNavHttpBody } from './types.js';

function indexNotReadyBody(): CodeNavHttpBody {
  return {
    indexReady: false,
    definition: null,
    definitions: [],
    references: [],
    symbols: [],
  };
}

export async function runSymbolsOp(ctx: CodeNavOpContext): Promise<CodeNavHttpBody> {
  if (fileBrowserReadInFlight()) return indexNotReadyBody();
  const symbols = await querySymbolsInFileFast(ctx.sessionParentPath, ctx.reqPath);
  if (symbols == null) return indexNotReadyBody();
  return { indexReady: true, symbols };
}
